import { useCallback, useState } from 'react';
import { isEqual, isFunction } from 'lodash';

const useSessionStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    const item = sessionStorage.getItem(key);
    return JSON.parse(item) || initialValue;
  });

  const setValue = useCallback(
    value => {
      setStoredValue(storedValue => {
        if (isEqual(value, storedValue)) {
          return storedValue;
        }
        const valueToStore = isFunction(value) ? value(storedValue) : value;
        sessionStorage.setItem(key, JSON.stringify(valueToStore));
        return valueToStore;
      });
    },
    [key]
  );
  return [storedValue, setValue];
};

export default useSessionStorage;
